import { useTranslation } from "react-i18next";
import { FiCheckCircle } from "react-icons/fi";

export default function PartnersSection() {
  const { t } = useTranslation();

  const partners = [
    {
      name: t("partners.education"),
      logo: "/images/logos/education.png",
      category: "Government",
    },
    {
      name: "UNICEF",
      logo: "/images/logos/unicef.png",
      category: "UN Agency",
    },
    {
      name: t("partners.health"),
      logo: "/images/logos/moh.jpg",
      category: "Government",
    },
    {
      name: t("partners.agriculture"),
      logo: "/images/logos/minstry_of_agri.jpg",
      category: "Government",
    },
    {
      name: "World Health Organization",
      logo: "/images/logos/who.png",
      category: "UN Agency",
    },
    {
      name: t("partners.gender"),
      logo: "/images/logos/mgcsw.png",
      category: "Government",
    },
  ];

  const ngos = [
    "UNICEF",
    "NORWEGEN AID",
    "CANADIAN AID",
    "SWIZLAND AID",
    "SAVE THE CHILDREN",
    "JAPAN AID",
    "UN-WHO",
    "UNDP",
    "WFP",
    "USAID",
    "UN-FAO",
    "UN-Habitat",
    "UN-WOMEN",
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 via-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-16">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-green-800 mb-6">
            {t("partners.title")}
          </h2>
          <div className="w-24 h-1 bg-green-600 mx-auto mb-6"></div>
          <p className="max-w-3xl mx-auto text-xl text-gray-700 leading-relaxed">
            {t("partners.description")}
          </p>
        </div>

        {/* Partners Grid */}
        <div className="mb-20">
          <h3 className="text-2xl font-bold text-gray-800 mb-8 text-center">
            Our Partners
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-6 md:gap-8">
            {partners.map((partner, index) => (
              <div
                key={index}
                className="group bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 p-6 border border-gray-100 hover:border-green-200"
              >
                <div className="flex flex-col items-center text-center space-y-4">
                  <div className="relative">
                    <div className="w-24 h-24 rounded-full bg-gradient-to-br from-green-50 to-green-100 p-2 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <img
                        src={partner.logo}
                        alt={partner.name}
                        className="w-full h-full object-contain rounded-full"
                      />
                    </div>
                    <div className="absolute -bottom-1 -right-1 bg-green-600 rounded-full p-1.5 shadow-lg">
                      <FiCheckCircle className="w-4 h-4 text-white" />
                    </div>
                  </div>
                  <div>
                    <h4 className="text-base font-semibold text-gray-800 mb-1 group-hover:text-green-700 transition-colors">
                      {partner.name}
                    </h4>
                    <p className="text-xs text-gray-500">{partner.category}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Donors Section */}
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 border border-gray-100">
          <div className="text-center mb-10">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              Our Donors & Supporters
            </h3>
            <p className="text-gray-600 max-w-2xl mx-auto">
              We are grateful for the generous support of these organizations
              and individuals who help us make a difference.
            </p>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
            {ngos.map((ngo, index) => (
              <div
                key={index}
                className="px-4 py-2 bg-gradient-to-r from-green-50 to-green-100 rounded-lg border border-green-200 hover:from-green-100 hover:to-green-200 hover:border-green-300 transition-all duration-300"
              >
                <span className="text-sm font-semibold text-green-800">
                  {ngo}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
